@use '@/styles/tokens' as *;

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.card {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 16px;
  border-radius: 12px;
  background: var(--surface-muted);
}
